import {ComponentSpecifier} from "./componentspecifier.mjs";

export class StorageManager{
    constructor(){
        var _componentSpecifierMap = new Map([]);


        Object.defineProperty(this,'componentSpecifierMap',{
            get : function(){ return _componentSpecifierMap ; }
         });        

    }

    // ==========
    // API (public)
    // ----------
    getComponentSpecifierMap(){ return this.componentSpecifierMap }

    getAllComponentNames(){
        var componentSpecifierMap = this.getComponentSpecifierMap(); 
        return [...componentSpecifierMap.keys()];
    }

    getComponents(name){ 
        var eventSpecifier = this.getComponentSpecifierMap().get(name);
        if (eventSpecifier) return eventSpecifier.getComponents();
        return;
    } 

    getSelector(name){ return this.getComponentSpecifierMap().get(name).getSelector(); }

    /* added 13-05-2021 */
    findComponents(name, findFn){ 
        var components = this.getComponents(name);
        var found = components.find(findFn);
        return found;
        //return this.getComponents(name).find(findFn);
    }


    // optional: selector, mandatory: component, name 
    // components: array of components 
    addComponents(components, name, selector){
        if (!(components instanceof Array)) throw new Error('ComponentStorage::addcomponents, param is not an array');
        var componentSpecifierMap = this.getComponentSpecifierMap();
        var componentSpecifier = new ComponentSpecifier(components, name, selector);
        componentSpecifierMap.set(name , componentSpecifier);
    }
    
    // optional: selector, mandatory: component, name 
    addComponent(component, name, selector){
        var componentSpecifierMap = this.getComponentSpecifierMap();
        var componentSpecifier = new ComponentSpecifier([component], name, selector);
        componentSpecifierMap.set(name , componentSpecifier);    
    }

    removeComponents(name){
        var componentSpecifierMap = this.getComponentSpecifierMap();
        componentSpecifierMap.delete(name);
    }

}